export default "__VITE_ASSET__CUN4TvRF__"